export default "__VITE_ASSET__7ad5bae6__"